import { action, makeObservable, observable } from "mobx";
import { ErrorMessages } from "../errorMessage";
import Validator from "../validator";

export enum BusinessActivityId {
    no = "NO",
    over50percent = "OVER_50_PERCENT",
    under50percent = "UNDER_50_PERCENT"
}

export interface BusinessActivityModel {
    value: BusinessActivityId | undefined;
    errorMessage: string;

    validateBusinessActivity: () => void;
}

export class DefaultBusinessActivityInBuilding implements BusinessActivityModel {
    @observable value: BusinessActivityId | undefined;
    @observable errorMessage: string;

    constructor(value: BusinessActivityId | undefined) {
        makeObservable(this);

        this.value = value;
        this.errorMessage = "";
    }

    @action
    public validateBusinessActivity = () => {
        if (!Validator.isNotEmpty(this.value!)) {
            this.errorMessage = ErrorMessages.required;
        } else {
            this.errorMessage = "";
        }
    }
}
